import apiDB from './api_db';

let companies = new apiDB({
    api_module: 'companies',
    table_key_name: 'company_id',
    reducer_name: 'companiesR',
    reducer_var: 'companies',
    action_prefix: 'COMPANIES'});

export default companies;